import _base from '../_base';
import { AppContent } from '../AppContent';

const content: AppContent = {
  ..._base,
};

export default content;
